const APP_ENVS = ["production", "preview", "development"] as const;

type AppEnv = (typeof APP_ENVS)[number];

function getAppEnv(): AppEnv {
  const env =
    typeof window !== "undefined"
      ? import.meta.env.VITE_APP_APP_ENV
      : process.env.VITE_APP_APP_ENV;

  if (APP_ENVS.includes(env as AppEnv)) {
    return env as AppEnv;
  }

  throw new Error(
    `Invalid APP_ENV: ${env}. Must be one of: ${APP_ENVS.join(", ")}`,
  );
}

export const APP_ENV: AppEnv = getAppEnv();
